import { EventKey } from '../../enums';
import { reducePlayerState, getPlaybackPauseState, getPlaybackSeekableRangeState, } from './utils';
export const WithUtil = (Base) => {
    return class PlayerWithUtil extends Base {
        triggerPlayerStateChanged() {
            this.triggerEvent({
                type: EventKey.PLAYER_STATE_CHANGED,
                canSeekForward: this.canSeekForward,
                canSeekBackward: this.canSeekBackward,
                canPause: this.canPause,
                seekableRange: this.seekableRange,
            });
        }
        setPlayerState(stateChange) {
            const seekableRange = stateChange
                .find((state) => state.seekableRange)?.seekableRange ?? this.seekableRange;
            stateChange.push(getPlaybackPauseState(this.currentState, this.canPause));
            stateChange.push(getPlaybackSeekableRangeState({
                currentPosition: this.currentPosition,
                seekableRange,
                currentCanSeekForward: this.canSeekForward,
                currentCanSeekBackward: this.canSeekBackward,
            }));
            const reducedState = reducePlayerState(stateChange);
            const oldState = {
                canPause: this.canPause,
                canSeekBackward: this.canSeekBackward,
                canSeekForward: this.canSeekForward,
                seekableRange: this.seekableRange,
            };
            const newState = {
                ...oldState,
                ...reducedState,
            };
            this._canSeekForward = newState.canSeekForward;
            this._canSeekBackward = newState.canSeekBackward;
            this._canPause = newState.canPause;
            this._seekableRange = newState.seekableRange;
            if (oldState.canSeekForward !== newState.canSeekForward) {
                this._logger?.info('Setting new state canSeekForward', newState.canSeekForward);
            }
            if (oldState.canSeekBackward !== newState.canSeekBackward) {
                this._logger?.info('Setting new state canSeekBackward', newState.canSeekBackward);
            }
            if (oldState.canPause !== newState.canPause) {
                this._logger?.info('Setting new state canPause', newState.canPause);
            }
            this.triggerPlayerStateChanged();
        }
    };
};
